import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type FloatingCtaProps = {
  anchorRef: React.RefObject<HTMLElement>;
};
export function FloatingCta({
  anchorRef
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = anchorRef.current;
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [anchorRef]);
  return <AnimatePresence data-id="element-30" data-mp="19784y1ia27co">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 md:inset-x-auto md:bottom-6 md:right-6 md:p-0" data-id="element-31" data-mp="197zt4r9jp2sx">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-cta-400 px-5 py-4 text-center text-base font-extrabold uppercase tracking-tight text-ink-950 shadow-[0_6px_0_0_#A16207,0_12px_30px_rgba(4,16,31,0.45)] hover:bg-cta-300 md:w-auto md:px-7" data-id="element-32" data-mp="21d5m2kssnqfq">
            Get the Blueprint for $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-33" data-mp="1ie1jnuvrcux1" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}